// extracted by mini-css-extract-plugin
export var sectionHeader = "SectionHeader-module--sectionHeader--BaxLB";
export var sectionHeaderSubTitle = "SectionHeader-module--sectionHeaderSubTitle--6Samf";
export var sectionHeadercircleContainer = "SectionHeader-module--sectionHeadercircleContainer--UPEDJ";